import _isNil from 'lodash/isNil';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import EntityDrawer from '@Components/InspectEntityComponents/EntityDrawer';
import Page from '@Components/Page/Page';
import { selectedEntityState } from '@Data/entities/Reducer';
import FoldersApi from '@Data/folders/Api';
import {
    isLoadingFoldersState,
    selectedFolderIdsState,
    visibleFoldersState,
} from '@Data/folders/Reducer';
import { IProject } from '@Data/projects/Interfaces';
import { ProjectActionType } from '@Data/projects/ProjectActionTypes';
import { selectedProjectState } from '@Data/projects/Reducer';
import { QualityControlApi } from '@Data/qualityControl/Api';
import { QualityControlState } from '@Data/qualityControl/Interfaces';
import { qualityControlStateState } from '@Data/qualityControl/Reducer';
import { ITeam } from '@Data/teams/Interfaces';
import { selectedTeamState } from '@Data/teams/Reducer';
import MapModalDialogue from '@Views/Project/components/ProjectModalDialogue/ProjectModalDialogue';
import { InProgressView } from './InProgressView';
import FoldersPanel from './components/Pending/FoldersPanel/FoldersPanel';
import { QualityControlMap } from './components/Pending/QualityControlMap';

export const QualityControlView = (): JSX.Element => {
    const { projectId, folderIds } = useParams();
    const selectedProject: IProject = useSelector(selectedProjectState);
    const selectedTeam: ITeam = useSelector(selectedTeamState);
    const [areGeoserverFeaturesLoading, setAreGeoserverFeaturesLoading] =
        useState<boolean>(false);

    const navigate = useNavigate();

    const qcState = useSelector(qualityControlStateState);
    const selectedEntity = useSelector(selectedEntityState);

    const visibleFolders = useSelector(visibleFoldersState);
    const selectedFolderIds = useSelector(selectedFolderIdsState);
    const isLoadingFolders = useSelector(isLoadingFoldersState);
    const [openDialogueType, setOpenDialogueType] =
        useState<ProjectActionType | null>(null);
    const getFolders = async () => {
        await FoldersApi.getFolders(selectedProject.project_id);
    };

    useEffect(() => {
        if (_isNil(projectId)) {
            navigate('/');
        }
    }, [projectId]);

    useEffect(() => {
        async function getPoles() {
            setAreGeoserverFeaturesLoading(true);
            let visibleFolderIds = visibleFolders.map((f) => f.folder_id);
            if (!_isNil(folderIds) && folderIds.length > 0) {
                // add in url parameters to multiselection
                let url_params = [];
                if (folderIds.indexOf(',') > -1) {
                    url_params = folderIds.split(',');
                } else if (folderIds.indexOf('-') > -1) {
                    url_params.push(folderIds);
                }

                visibleFolderIds = visibleFolderIds.concat(url_params);
            }

            await QualityControlApi.initializeGeoserverData(
                parseInt(projectId),
                visibleFolderIds.filter(
                    (f) => !_isNil(f) && f.indexOf('-') > -1
                )
            );
            setAreGeoserverFeaturesLoading(false);
        }
        console.log('get poles', visibleFolders, folderIds);
        getPoles();
    }, [projectId, folderIds, visibleFolders, selectedFolderIds]);
    const handleDialogueClose = () => {
        setOpenDialogueType(null);
    };

    const handleCompleteProcessEvent = () => {
        handleDialogueClose();
    };
    console.log('re-rendering quality control view');
    const qcv =
        qcState === QualityControlState.PENDING ? (
            <React.Fragment>
                <Page>
                    <FoldersPanel
                        selectedProject={selectedProject}
                        isLoading={areGeoserverFeaturesLoading}
                        onManageProject={getFolders}
                    />

                    <QualityControlMap
                        isLoading={areGeoserverFeaturesLoading}
                    />

                    {selectedEntity && (
                        <EntityDrawer selectedEntity={selectedEntity} />
                    )}
                </Page>
                {selectedProject && (
                    <MapModalDialogue
                        type={openDialogueType}
                        isOpen={!_isNil(openDialogueType)}
                        onCancel={handleDialogueClose}
                        projectId={selectedProject.project_id}
                        onComplete={handleCompleteProcessEvent}
                    />
                )}
            </React.Fragment>
        ) : (
            <InProgressView
                isLoading={isLoadingFolders}
                selectedProject={selectedProject}
                selectedTeam={selectedTeam}
                onManageProject={getFolders}
            />
        );

    return qcv;
};
